#!/usr/bin/env node

import chalk from "chalk";
import { Command } from "commander";
import { addCommand } from "./commands/add";
import { initCommand } from "./commands/init";
import { listCommand } from "./commands/list";
import { setVerbose } from "./utils/logger";

const program = new Command();

program
  .name("@pyyupsk/pixelarticons")
  .description(
    "A community-driven CLI tool to generate React components from Pixelarticons SVG files",
  )
  .version("1.0.0")
  .option("-v, --verbose", "Enable verbose logging")
  .hook("preAction", (thisCommand) => {
    const opts = thisCommand.opts();
    if (opts.verbose) {
      setVerbose(true);
    }
  });

// Init command
program
  .command("init")
  .description("Initialize configuration file")
  .option("-o, --output <path>", "Output directory for generated components")
  .option("--typescript", "Use TypeScript (default: true)")
  .option("--no-typescript", "Use JavaScript")
  .option("-f, --force", "Force overwrite existing config file")
  .action(async (options) => {
    await initCommand(options);
  });

// Add command
program
  .command("add [icons...]")
  .description("Generate React components for specific icons")
  .option("-a, --all", "Generate all icon components")
  .option("-o, --output <path>", "Output directory (overrides config)")
  .option("--typescript", "Use TypeScript")
  .option("--no-typescript", "Use JavaScript")
  .option("-c, --config <path>", "Path to config file")
  .option("-f, --force", "Force overwrite existing components")
  .action(async (icons, options) => {
    await addCommand(icons, options);
  });

// List command
program
  .command("list")
  .description("List all available icon names")
  .option("-f, --filter <pattern>", "Filter icons by pattern")
  .action(async (options) => {
    await listCommand(options);
  });

// Handle unknown commands
program.on("command:*", () => {
  console.error(chalk.red(`\nInvalid command: ${program.args.join(" ")}`));
  console.log(
    chalk.cyan(
      `\nRun ${chalk.bold("@pyyupsk/pixelarticons --help")} to see available commands`,
    ),
  );
  process.exit(1);
});

// Show help if no command provided
if (process.argv.length === 2) {
  program.help();
}

program.parse(process.argv);
